import { __extends, __makeTemplateObject, __decorate, __metadata, __assign as _assign } from '../../node_modules/tslib/tslib.es6.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x, nothing as A } from '../../node_modules/lit-html/lit-html.js';
import '../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../node_modules/@babel/runtime/regenerator/index.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ifDefined as l } from '../../node_modules/lit-html/directives/if-defined.js';
import getClassName from '../../node_modules/@fmr-ap142296/brick-helpers/dist/src/functions/get-class-name.js';
import { ScopedElementsMixin } from '../utilities/scoped-elements/scoped-elements.mixin.js';
import { PvdSlotifyBaseComponent } from '../pvd-base-component/pvd-slotify-base-component.js';
import { StandardSize, Size } from '../pvd-utils/enums/size.js';

var DEFAULT_DISABLED = false;
var DEFAULT_SIZE = undefined;
var DEFAULT_HREF = "#";
var DEFAULT_EXTERNAL_LINK_ICON = 'action__open-link';
var DEFAULT_NEW_WINDOW_STRING = 'Opens in a new window';
var LINK_ANCHOR_PROTECTED_ATTR_MAP = new Map([
    ['aria-describedby', 'pvd-aria-describedby'],
    ['aria-label', 'pvd-aria-label'],
    ['aria-disabled', 'pvd-disabled'],
    ['class', 'pvd-class'],
    ['disabled', 'pvd-disabled'],
    ['id', 'pvd-id'],
    ['rel', 'pvd-new-window'],
    ['target', 'pvd-new-window'],
]);
var LINK_BUTTON_PROTECTED_ATTR_MAP = new Map([
    ['aria-describedby', 'pvd-aria-describedby'],
    ['aria-label', 'pvd-aria-label'],
    ['aria-disabled', 'pvd-disabled'],
    ['class', 'pvd-class'],
    ['disabled', 'pvd-disabled'],
    ['id', 'pvd-id'],
]);
/**
 * Providence Link component.
 * @see {@link https://providence.fmr.com/components/link/link.html|Link documentation}
 */
var PvdLink = /** @class */ (function (_super) {
    __extends(PvdLink, _super);
    function PvdLink() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pvdDisabled = DEFAULT_DISABLED;
        _this.pvdSize = DEFAULT_SIZE;
        _this.pvdHref = DEFAULT_HREF;
        _this.pvdNewWindowString = DEFAULT_NEW_WINDOW_STRING;
        return _this;
        // #endregion
    }
    Object.defineProperty(PvdLink, "scopedElements", {
        get: function () {
            // $namespace-$name-$extendingComponentName
            return {
                'pvd-scoped-icon': customElements.get("".concat(this.namespace, "-icon")),
            };
        },
        enumerable: false,
        configurable: true
    });
    // #endregion
    // #region public methods
    /**
     * Overrides focus method so that focus is given to the native button or link
     * element.
     *
     * @param options - options that are passed through unmodified to the native
     * `focus` method
     */
    PvdLink.prototype.focus = function (options) {
        var linkEl = this.querySelector('.pvd-link__link');
        if (linkEl) {
            linkEl.focus(options);
        }
    };
    // #endregion
    // #region private methods
    /**
     * Sets attributes on the link element that are coming from pvdNativeAnchorAttributes
     * @param prevAttr optional, if user updates pvdNativeAnchorAttributes, this will remove/update existing attributes
     */
    PvdLink.prototype.setNativeAnchorAttributes = function (prevAttr) {
        var targetElement = this.querySelector('.pvd-link__link');
        this.setNativeAttributes(this.pvdNativeAnchorAttributes, LINK_ANCHOR_PROTECTED_ATTR_MAP, targetElement, prevAttr);
    };
    /**
     * Sets attributes on the button element that are coming from pvdNativeButtonAttributes
     * @param prevAttr optional, if user updates pvdNativeButtonAttributes, this will remove/update existing attributes
     */
    PvdLink.prototype.setNativeButtonAttributes = function (prevAttr) {
        var targetElement = this.querySelector('.pvd-link__link');
        this.setNativeAttributes(this.pvdNativeButtonAttributes, LINK_BUTTON_PROTECTED_ATTR_MAP, targetElement, prevAttr);
    };
    Object.defineProperty(PvdLink.prototype, "hasIcon", {
        /**
         * Determines if the consumer provided a slotted icon-left OR icon-right
         */
        get: function () {
            return this.hasIconLeft || this.hasIconRight;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdLink.prototype, "hasIconLeft", {
        /**
         * Determines if the consumer provided a slotted icon-left
         */
        get: function () {
            return !!this.pvdIconLeft || this.isSlotUsed('icon-left');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdLink.prototype, "hasIconRight", {
        /**
         * Determines if the consumer provided a slotted icon-right
         */
        get: function () {
            return !!this.pvdIconRight || this.isSlotUsed('icon-right');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdLink.prototype, "hasText", {
        /**
         * Determines if the consumer provided pvdText or slotted text
         */
        get: function () {
            return !!this.pvdText || this.isSlotUsed();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdLink.prototype, "iconOnly", {
        /**
         * Determines if there is an icon without text
         */
        get: function () {
            return !this.hasText && this.hasIcon;
        },
        enumerable: false,
        configurable: true
    });
    // #endregion
    // #region LitElement lifecycles
    PvdLink.prototype.updated = function (changedProperties) {
        _super.prototype.updated.call(this, changedProperties);
        if (changedProperties.has('pvdNewWindow') && this.pvdNewWindow) {
            this.pvdIconRight = DEFAULT_EXTERNAL_LINK_ICON;
        }
        else if (changedProperties.has('pvdNewWindow') && !this.pvdNewWindow) {
            this.pvdIconRight = undefined;
        }
        if (this.pvdNativeAnchorAttributes) {
            var prevAttr = changedProperties.get('pvdNativeAnchorAttributes');
            // if native attributes are being set, go through the logic of applying attributes to target element
            this.setNativeAnchorAttributes(prevAttr);
        }
        if (this.pvdNativeButtonAttributes) {
            var prevAttr = changedProperties.get('pvdNativeButtonAttributes');
            // if native attributes are being set, go through the logic of applying attributes to target element
            this.setNativeButtonAttributes(prevAttr);
        }
    };
    PvdLink.prototype.renderDisabledCover = function () {
        var namespace = this.constructor.namespace;
        return x(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ", "\n    "])), this.pvdDisabled ? x(templateObject_1 || (templateObject_1 = __makeTemplateObject(["<span class=\"", "-link__disabled-cover\"></span>"], ["<span class=\"", "-link__disabled-cover\"></span>"])), namespace) : A);
    };
    PvdLink.prototype.renderLeftIcon = function () {
        return this.hasIconLeft
            ? x(templateObject_3 || (templateObject_3 = __makeTemplateObject(["<span class=\"pvd-link__icon pvd-link__icon--left\"\n          ><s-slot name=\"icon-left\">", "</s-slot></span\n        >"], ["<span class=\"pvd-link__icon pvd-link__icon--left\"\n          ><s-slot name=\"icon-left\">", "</s-slot></span\n        >"])), this.renderIcon(this.pvdIconLeft)) : x(templateObject_4 || (templateObject_4 = __makeTemplateObject(["<s-slot name=\"icon-left\"></s-slot>"], ["<s-slot name=\"icon-left\"></s-slot>"])));
    };
    PvdLink.prototype.renderRightIcon = function () {
        return this.hasIconRight
            ? x(templateObject_5 || (templateObject_5 = __makeTemplateObject(["<span class=\"pvd-link__icon pvd-link__icon--right\"\n          ><s-slot name=\"icon-right\">", "</s-slot></span\n        >"], ["<span class=\"pvd-link__icon pvd-link__icon--right\"\n          ><s-slot name=\"icon-right\">", "</s-slot></span\n        >"])), this.renderIcon(this.pvdIconRight)) : x(templateObject_6 || (templateObject_6 = __makeTemplateObject(["<s-slot name=\"icon-right\"></s-slot>"], ["<s-slot name=\"icon-right\"></s-slot>"])));
    };
    PvdLink.prototype.renderIcon = function (iconName) {
        return this.scopeTemplate(templateObject_7 || (templateObject_7 = __makeTemplateObject(["<pvd-scoped-icon\n      pvd-name=\"", "\"\n      pvd-size=\"", "\"\n    ></pvd-scoped-icon>"], ["<pvd-scoped-icon\n      pvd-name=\"", "\"\n      pvd-size=\"", "\"\n    ></pvd-scoped-icon>"])), iconName, this.pvdSize === StandardSize.large ? Size.medium : Size.small);
    };
    PvdLink.prototype.renderText = function () {
        return this.hasText
            ? x(templateObject_8 || (templateObject_8 = __makeTemplateObject(["<span class=\"pvd-link__text\"><s-slot>", "</s-slot></span>"], ["<span class=\"pvd-link__text\"><s-slot>", "</s-slot></span>"])), this.pvdText) : x(templateObject_9 || (templateObject_9 = __makeTemplateObject(["<s-slot></s-slot>"], ["<s-slot></s-slot>"])));
    };
    PvdLink.prototype.renderNewWindowString = function () {
        return this.pvdNewWindow
            ? x(templateObject_10 || (templateObject_10 = __makeTemplateObject(["<span class=\"pvd-link__screen-reader-text\">\n          ", "</span\n        >"], ["<span class=\"pvd-link__screen-reader-text\">\n          ", "</span\n        >"])), this.pvdNewWindowString || DEFAULT_NEW_WINDOW_STRING) : A;
    };
    PvdLink.prototype.renderLinkContents = function () {
        // unable to dynamically create an named s-slot (e.g., <s-slot name="icon-${position}"></s-slot> doesn't work)
        var leftIcon = this.renderLeftIcon();
        var rightIcon = this.renderRightIcon();
        var text = this.renderText();
        var newWindowString = this.renderNewWindowString();
        return x(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", "", "", "", ""], ["", "", "", "", ""])), leftIcon, text, rightIcon, newWindowString);
    };
    PvdLink.prototype.renderLink = function () {
        return x(templateObject_14 || (templateObject_14 = __makeTemplateObject([" ", ""], [" ", ""])), this.pvdTrigger
            ? x(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", "\n          <button\n            class=\"pvd-link__link", "\"\n            id=\"", "\"\n            ?disabled=\"", "\"\n            tabindex=\"", "\"\n            aria-disabled=\"", "\"\n            aria-describedby=\"", "\"\n            aria-label=\"", "\"\n          >\n            ", "\n          </button>"], ["", "\n          <button\n            class=\"pvd-link__link", "\"\n            id=\"", "\"\n            ?disabled=\"", "\"\n            tabindex=\"", "\"\n            aria-disabled=\"", "\"\n            aria-describedby=\"", "\"\n            aria-label=\"", "\"\n          >\n            ", "\n          </button>"])), this.renderDisabledCover(), this.pvdClass ? " ".concat(this.pvdClass) : "", l(this.pvdId), this.pvdDisabled, l(this.pvdDisabled ? '-1' : undefined), l(this.a11yBoolean(this.pvdDisabled)), l(this.pvdAriaDescribedby), l(this.pvdAriaLabel), this.renderLinkContents()) : x(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", "\n          <a\n            class=\"pvd-link__link", "\"\n            id=\"", "\"\n            ?disabled=\"", "\"\n            tabindex=\"", "\"\n            aria-disabled=\"", "\"\n            aria-describedby=\"", "\"\n            aria-label=\"", "\"\n            href=\"", "\"\n            target=\"", "\"\n            rel=\"", "\"\n            >", "</a\n          >"], ["", "\n          <a\n            class=\"pvd-link__link", "\"\n            id=\"", "\"\n            ?disabled=\"", "\"\n            tabindex=\"", "\"\n            aria-disabled=\"", "\"\n            aria-describedby=\"", "\"\n            aria-label=\"", "\"\n            href=\"", "\"\n            target=\"", "\"\n            rel=\"", "\"\n            >", "</a\n          >"])), this.renderDisabledCover(), this.pvdClass ? " ".concat(this.pvdClass) : "", l(this.pvdId), this.pvdDisabled, l(this.pvdDisabled ? '-1' : undefined), l(this.a11yBoolean(this.pvdDisabled)), l(this.pvdAriaDescribedby), l(this.pvdAriaLabel), l(this.pvdHref), l(this.pvdNewWindow ? '_blank' : undefined), l(this.pvdNewWindow ? 'noopener' : undefined), this.renderLinkContents()));
    };
    PvdLink.prototype.render = function () {
        var classMap = {
            default: "".concat(this.constructor.namespace, "-link-root"),
            modifierPrefix: 'pvd-link',
            modifiers: [
                {
                    condition: this.iconOnly,
                    className: 'icon-only',
                },
                {
                    condition: this.hasIconLeft,
                    className: 'icon-left',
                },
                {
                    condition: this.hasIconRight,
                    className: 'icon-right',
                },
                {
                    condition: this.pvdDisabled,
                    className: 'disabled',
                },
                {
                    condition: this.pvdTrigger,
                    className: 'trigger',
                },
                {
                    condition: this.pvdDisableUnderline,
                    className: 'disable-underline',
                },
                {
                    condition: this.pvdNewWindow,
                    className: 'new-window',
                },
                {
                    condition: true,
                    className: "".concat(this.pvdSize),
                },
            ],
        };
        return x(templateObject_15 || (templateObject_15 = __makeTemplateObject(["<span class=\"", "\">", "</span>"], ["<span class=\"", "\">", "</span>"])), getClassName(classMap), this.renderLink());
    };
    //#region Component configuration
    PvdLink.componentName = 'link';
    __decorate([
        n({
            type: String,
            reflect: true,
            attribute: 'pvd-id',
        }),
        __metadata("design:type", String)
    ], PvdLink.prototype, "pvdId", void 0);
    __decorate([
        n({
            type: String,
            reflect: true,
            attribute: 'pvd-class',
        }),
        __metadata("design:type", String)
    ], PvdLink.prototype, "pvdClass", void 0);
    __decorate([
        n(_assign({ type: Boolean, reflect: true, attribute: 'pvd-disabled' }, PvdSlotifyBaseComponent.booleanAttribute('pvd-disabled'))),
        __metadata("design:type", Boolean)
    ], PvdLink.prototype, "pvdDisabled", void 0);
    __decorate([
        n(_assign({ type: String, reflect: true, attribute: 'pvd-size' }, PvdSlotifyBaseComponent.hasChanged(StandardSize))),
        __metadata("design:type", Number)
    ], PvdLink.prototype, "pvdSize", void 0);
    __decorate([
        n({
            type: String,
            reflect: true,
            attribute: 'pvd-text',
        }),
        __metadata("design:type", String)
    ], PvdLink.prototype, "pvdText", void 0);
    __decorate([
        n({
            type: String,
            reflect: true,
            attribute: 'pvd-href',
        }),
        __metadata("design:type", String)
    ], PvdLink.prototype, "pvdHref", void 0);
    __decorate([
        n({
            type: String,
            attribute: 'pvd-new-window-string',
        }),
        __metadata("design:type", String)
    ], PvdLink.prototype, "pvdNewWindowString", void 0);
    __decorate([
        n({ type: String, reflect: true, attribute: 'pvd-icon-right' }),
        __metadata("design:type", String)
    ], PvdLink.prototype, "pvdIconRight", void 0);
    __decorate([
        n({ type: String, reflect: true, attribute: 'pvd-icon-left' }),
        __metadata("design:type", String)
    ], PvdLink.prototype, "pvdIconLeft", void 0);
    __decorate([
        n(_assign({ type: Boolean, reflect: true, attribute: 'pvd-trigger' }, PvdSlotifyBaseComponent.booleanAttribute('pvd-trigger'))),
        __metadata("design:type", Boolean)
    ], PvdLink.prototype, "pvdTrigger", void 0);
    __decorate([
        n(_assign({ type: Boolean, reflect: true, attribute: 'pvd-new-window' }, PvdSlotifyBaseComponent.booleanAttribute('pvd-new-window'))),
        __metadata("design:type", Boolean)
    ], PvdLink.prototype, "pvdNewWindow", void 0);
    __decorate([
        n(_assign({ type: Boolean, reflect: true, attribute: 'pvd-disable-underline' }, PvdSlotifyBaseComponent.booleanAttribute('pvd-disable-underline'))),
        __metadata("design:type", Boolean)
    ], PvdLink.prototype, "pvdDisableUnderline", void 0);
    __decorate([
        n({
            type: String,
            reflect: true,
            attribute: 'pvd-aria-describedby',
        }),
        __metadata("design:type", String)
    ], PvdLink.prototype, "pvdAriaDescribedby", void 0);
    __decorate([
        n({
            type: String,
            reflect: true,
            attribute: 'pvd-aria-label',
        }),
        __metadata("design:type", String)
    ], PvdLink.prototype, "pvdAriaLabel", void 0);
    __decorate([
        n({ type: Object, attribute: 'pvd-native-anchor-attributes' }),
        __metadata("design:type", Object)
    ], PvdLink.prototype, "pvdNativeAnchorAttributes", void 0);
    __decorate([
        n({ type: Object, attribute: 'pvd-native-button-attributes' }),
        __metadata("design:type", Object)
    ], PvdLink.prototype, "pvdNativeButtonAttributes", void 0);
    return PvdLink;
}(ScopedElementsMixin(PvdSlotifyBaseComponent)));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;

export { DEFAULT_DISABLED, DEFAULT_EXTERNAL_LINK_ICON, DEFAULT_HREF, DEFAULT_NEW_WINDOW_STRING, DEFAULT_SIZE, LINK_ANCHOR_PROTECTED_ATTR_MAP, LINK_BUTTON_PROTECTED_ATTR_MAP, PvdLink };
